import React, { useState } from "react";

import { Input, Select, Space, Typography,DatePicker, ConfigProvider, Switch } from "antd";
import deDE from 'antd/locale/de_DE';
import { isValid, printFormat } from "iban";
import schoolsData from "../data/schools.json";
import bicData from "../data/blz-data.json";
const { Option } = Select;
const { Text, Link } = Typography;

function PersData({ personalData, setPersonalData, schoolData, setSchoolData, confirmation, setConfirmation, dataProtection, setDataProtection }) {
  const [isValIban, setIsValIban] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  
  // API-Abfragen für PLZ und BIC
  const fetchPlaceByPostalCode = async (postalCode) => {
    try {
      const response = await fetch(`https://api.zippopotam.us/DE/${postalCode}`);
      if (!response.ok) throw new Error(`Kein Ort für PLZ ${postalCode} gefunden`);
      const data = await response.json();
      
      if (data.places?.[0]) {
        setPersonalData(prev => ({ 
          ...prev, 
          city: data.places[0]["place name"] 
        }));
      }
    } catch (error) {
      console.error("Fehler bei der API-Abfrage:", error);
      setPersonalData(prev => ({ ...prev, city: prev.city }));
    }
  };

  const getBlzFromIban = (iban) => {
    const cleanIban = iban.replace(/\s+/g, '');
    if (!cleanIban.startsWith("DE") || cleanIban.length < 12) return null;
    return Number(cleanIban.slice(4, 12)); // Stellen 5–12 (0-basiert)

  }
  
  
  const getBicFromIban = (iban) => {
    const blz = getBlzFromIban(iban);
    if (!blz) return null;
    
    const entry = bicData.find(item => item.Bankleitzahl === blz);
    return entry?.BIC || null;
  }
  

  const handleChangeVendor = (e) => {
    const splitIntoBlocks = (text) => text.replace(/\s/g, '').match(/.{1,4}/g)?.join(' ') || '';
    setPersonalData(prev => ({ ...prev, vendor: splitIntoBlocks(e.target.value) }));
  };

  const handleChangeIban = (e) => {
  const input = e.target.value.replace(/\s+/g, "");
  const formattedIban = printFormat(input, " ");
  const valid = isValid(input);

  setIsValIban(valid);
  setPersonalData(prev => ({ ...prev, iban: formattedIban }));

  if (valid) {
    const bic = getBicFromIban(input);
    setPersonalData(prev => ({
      ...prev,
      bic: bic || "Kein BIC gefunden"
    }));
  }
};

  // Styles
  const sectionStyle = { marginBottom: 24 };
  const inputStyle = { width: "100%", maxWidth: 300 };

  return (
    <div className="personal-data-page" style={{ padding: "0 30px", marginTop: "30px" }}>
      {/* Persönliche Daten */}
      <div style={sectionStyle}>
        <Text strong>Persönliche Daten</Text>
        <Space direction="vertical" style={{ width: "100%", marginTop: 8 }}>
          <Input
            placeholder="Name"
            allowClear
            value={personalData.name}
            onChange={(e) => setPersonalData(prev => ({ ...prev, name: e.target.value }))}
            style={inputStyle}
          />
          <Input
            placeholder="Vorname"
            allowClear
            value={personalData.firstname}
            onChange={(e) => setPersonalData(prev => ({ ...prev, firstname: e.target.value }))}
            style={inputStyle}
          />
          <Space.Compact style={{ width: "100%" }}>
            <Input
              placeholder="Straße"
              allowClear
              value={personalData.street}
              style={{ width: "80%", maxWidth: 240 }}
              onChange={(e) => setPersonalData(prev => ({ ...prev, street: e.target.value }))}
            />
            <Input
              placeholder="Hausnr."
              allowClear
              value={personalData.housenumber}
              style={{ width: "20%", maxWidth: 60 }}
              onChange={(e) => setPersonalData(prev => ({ ...prev, housenumber: e.target.value }))}
            />
          </Space.Compact>
          <Space.Compact style={{ width: "100%" }}>
            <Input
              placeholder="PLZ"
              allowClear
              value={personalData.postalCode}
              style={{ width: "27%", maxWidth: 81 }}
              onChange={(e) => {
                const value = e.target.value;
                setPersonalData(prev => ({ ...prev, postalCode: value }));
                if (value.length === 5) fetchPlaceByPostalCode(value);
                
              }}
            />
            <Input
              placeholder="Ort"
              allowClear
              value={personalData.city}
              onChange={(e) => {
                const value = e.target.value;
                setPersonalData(prev => ({ ...prev, city: value }));
                
              }}
              style={{ width: "73%", maxWidth: 219 }}
            />
          </Space.Compact>
          <Input
            placeholder="E-Mail"
            allowClear
            value={personalData.email}
            onChange={(e) => setPersonalData(prev => ({ ...prev, email: e.target.value }))}
            style={inputStyle}
          />
        </Space>
      </div>

      {/* Bankdaten */}
      <div style={sectionStyle}>
        <Text strong>Zahlungsdaten</Text>
        <Space direction="vertical" style={{ width: "100%", marginTop: 8 }}>
          <Input
            placeholder="Kreditornummer"
            allowClear
            value={personalData.vendor}
            onChange={handleChangeVendor}
            style={inputStyle}
          />
          <Input
            placeholder="Bank"
            allowClear
            value={personalData.bank}
            onChange={(e) => setPersonalData(prev => ({ ...prev, bank: e.target.value }))}
            style={inputStyle}
          />
          <Input
            placeholder="IBAN"
            allowClear
            value={personalData.iban}
            onChange={handleChangeIban}
            status={!isValIban && personalData.iban ? "error" : ""}
            style={inputStyle}
          />
          <Input
            placeholder="BIC"
            value={personalData.bic}
            readOnly={!!personalData.bic && personalData.bic !== "Kein BIC gefunden"}
            style={inputStyle}
          />
        </Space>
      </div>

      {/* Schulinformationen */}
      <div style={sectionStyle}>
        <Text strong>Schule</Text>
        
        {!isEditing ? (
          <div>
          <Input
            placeholder="Schule auswählen"
            value={schoolData.name ? 
            
            `${schoolData.name}(${schoolData.city})` : ""}
            onFocus={() => setIsEditing(true)}
            style={{ ...inputStyle, marginTop: 8 }}
          />
       </div> ) : (
          <Space direction="vertical" style={{ width: "100%", marginTop: 8 }}>
            <Select
              showSearch
              placeholder="Schulname"
              value={schoolData.name || null}
              onChange={(value) => {
                const [name, city] = value.split('.');
                const selected = schoolsData.find(s => s.city === city && s.name === name);
                if (selected) {
                  setSchoolData({
                    city: selected.city,
                    name: selected.name,
                    postalCode: selected.postalCode,
                    street: selected.street,
                    housenumber: selected.housenumber
                  });
                  setIsEditing(false);
                }
              }}
              optionLabelProp="label"
              style={inputStyle}
            >
  {schoolsData
  .slice()
  .sort((a, b) => {
    const nameCompare = a.name.localeCompare(b.name);
    if (nameCompare !== 0) return nameCompare;
    return a.city.localeCompare(b.city);
  })
  .map((item, index) => (
    <Option 
      key={index} 
      value={`${item.name}.${item.city}`} 
      label={item.name}
    >
      <div>
        <div>{item.name}</div>
        <div style={{ color: '#666', fontSize: '0.8em' }}>
          {item.city}
        </div>
      </div>
    </Option>
))}

            </Select>

            <Space.Compact style={{ width: "100%" }}>
              <Input
                placeholder="PLZ"
                value={schoolData.postalCode}
                onChange={(e) => setSchoolData(prev => ({ ...prev, postalCode: e.target.value }))}
                style={{ width: "20%", maxWidth: 70 }}
              />
              <Input
                placeholder="Ort"
                value={schoolData.city}
                onChange={(e) => setSchoolData(prev => ({ ...prev, city: e.target.value }))}
                style={{ width: "80%", maxWidth: 230 }}
              />
            </Space.Compact>

            <Space.Compact style={{ width: "100%" }}>
              <Input
                placeholder="Straße"
                value={schoolData.street}
                onChange={(e) => setSchoolData(prev => ({ ...prev, street: e.target.value }))}
                style={{ width: "80%", maxWidth: 240 }}
              />
              <Input
                placeholder="Hausnr."
                value={schoolData.housenumber}
                onChange={(e) => setSchoolData(prev => ({ ...prev, housenumber: e.target.value }))}
                style={{ width: "20%", maxWidth: 60 }}
              />
            </Space.Compact>
          </Space>
          
        )}
        
      </div>
     


{/* Bestätigung */}
<div style={{ ...sectionStyle, borderTop: "1px solid #eee", paddingTop: 16 }}>
  <Text strong>Bestätigung der Angaben</Text>
  <Space direction="vertical" style={{ width: "100%", marginTop: 8 }}>
    <Input
      placeholder="Name der erklärenden Person"
      allowClear
      value={confirmation.name}
      onChange={(e) => setConfirmation(prev => ({ ...prev, name: e.target.value }))}
      style={inputStyle}
    />
    <ConfigProvider locale={deDE}>
    <DatePicker
      value={confirmation.date}
      onChange={(date) => setConfirmation(prev => ({ ...prev, date }))}
      format="DD.MM.YYYY"
      style={inputStyle}
    />
    </ConfigProvider>
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <Switch
        checked={confirmation.confirmed}
        onChange={(checked) => {
          setConfirmation(prev => ({ ...prev, confirmed: checked }));
          }}
      />
      <Text>
        Hiermit bestätige ich, dass alle Angaben korrekt und vollständig sind.
      </Text>
    </div>
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <Switch
        checked={dataProtection}
        onChange={(checked) => {
          setDataProtection(checked);
          }}
      />
      <Text>
       <Link
      href="/datenschutzhinweise.html"
      target="_blank"
      rel="noopener noreferrer"
    >
      Datenschutzhinweise
    </Link>{" "}
    gelesen.
      </Text>
    </div>
  </Space>
</div>



    </div>
  );
}

export default PersData;